require('fixed-data-table-2/dist/fixed-data-table.css')

require('./base-new.less')
require('./billings.less')
require('./menu-new.less')
require('./form.less')
require('./button.less')
require('./tab.less')
require('./table-new.less')
require('./tree.less')
require('./modal.less')
require('./pagination.less')
require('./home-new.less')
require('./login-new.less')
require('./alert.less')
require('./spinBar.less')
require('./panel.less')
require('./billing/inputButtonPanel.less')
require('./large-screen.less')
require('./large-screen2.less')
require('./payBar.less')
require('./waittingtask.less')
require('./billing/payIcon.less')



// WEBPACK FOOTER //
// ./src/yxyweb/client/styles/default/index.jsx